import React from "react";
import { Divider, Paper, Box } from "@material-ui/core";
import { useStyles } from "../../../shared/styles/useStyles";
import { WorkScheduleForm } from "./work-calendar-forms/WorkScheduleForm";
import {SpecialDaysSection} from "./work-calendar-forms/SpecialDaysSection";

export const GeneralTab = () => {
  const classes = useStyles();

  return (
    <>
      <Divider variant="fullWidth" />
      <Paper square className={classes.paper}>
        <Box p={3}>
          <WorkScheduleForm />
          <SpecialDaysSection />
        </Box>
      </Paper>
    </>
  );
};
